export const MODULE_TYPE = {
  full: "full",
  short: "short",
  call: "call",
};
